/**
 * Returns the same value as the given argument.
 *
 * @example
 * ```ts
 * identity(5); // 5
 * ```
 */
function identity(a) {
    return a;
}
export default identity;
//# sourceMappingURL=identity.js.map